import { useCallback, useEffect, useState } from 'react';
import { readPlantScope, subscribePlantScope, type PlantScope } from '../../lib/plantScope';

/**
 * The current plant, kept in sync across every surface that reads it.
 *
 * Lives in its own module so the components that use it export only
 * components, which is what React Fast Refresh needs.
 */
export default function usePlantScope(): PlantScope {
  const [scope, setScope] = useState<PlantScope>(readPlantScope);
  const refresh = useCallback(() => setScope(readPlantScope()), []);
  useEffect(() => subscribePlantScope(refresh), [refresh]);
  return scope;
}
